import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const getAtencionById = async ( idAtencion ) => {

  const query = `                    
      query getAtencionId($idAtencion: String!){
        getAtencionId(idAtencion: $idAtencion) {
          atencionMedica{
              id
              cita {
                id
                establecimiento { id }
              }
              tipoConsulta{ id descripcion }
              anamnesisSet{
                id
                motivoConsulta
                problemaActual
                ptratamiento
              }
              ginecologiaSet {
                camposgeneral
              }
              anteperanamSet{
                id
                antescedentesPersonales{
                  descripcion
                  id
                }
                descripcionGeneral
              }
              antefamanamSet{
                id
                antescedentesFamiliares{
                  descripcion
                  id
                }
                descripcionGeneral
              }
              revorganamSet{
                  id
                  revisionorganos{
                      descripcion
                      id
                  }   
                  descripcionGeneral
              }
              exafisanamSet{
                  id
                  examenfisico{
                      descripcion
                  }
                  descripcionGeneral
              }
              recetaSet{
                  id
                  medicamentosRecetados{
                      id
                      medicamento{
                          nombre
                          id
                      }
                      cantidad
                      dosis
                      frecuencia
                      duracion
                      estado
                  }
              }
              envioimagenSet{
                  id
                  lateralidad{
                      nombre
                  }
                  imagen{
                      nombre
                  }
                  motivoSolicitud
                  numeroOrdenAs400
                  resumenClinico
              }
              solicitudterapiaSet{
                  id
                  terapia{
                      nombre
                      id
                  }
                  cantidad
                  numeroOrdenAs400
                  motivoSolicitud
                  resumenClinico
                  estado
              }
              procedimientocitaSet{
                  id
                  procedimiento{
                      descripcion
                      id
                  }
                  noas400
                  motivoSolicitud
                  resumenClinico
                  estado
              }
            
              solicitudcirugiamedicaSet{
                  id
                  cirugiaMedica{
                      nombre
                  }
                  numeroOrdenAs400
                  motivoSolicitud
                  resumenClinico
              }
              diaganamSet{
                  id
                  diagnostico{
                      descripcion
                  }
                  esprincipal
                  tipoDiagnostico{
                  descripcion
                  }
              }
                    estudiolabSet {
                      modalidad {
                      descripcion
                      }
                      LabAs400 {
                      numeroOrden
                      fechaOrdenOrion
                      idslaboratorios
                      }
                  }
          }                          
          status
          message
        }
      }
    `;
  const variables = {
    idAtencion: String(idAtencion),
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });

    console.log( response );
    if( response.data.data.getAtencionId.status !== 'success' ) return null;
    return response.data.data.getAtencionId.atencionMedica;

  } catch (error) {
    console.error("Error getAtencionById", error);
    return error;
  }
}